var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"bg"},[_c('AddDeliverySchedule')],1),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.deliverySchedules,"items-per-page":10,"mobile-breakpoint":0},scopedSlots:_vm._u([{key:"item.updated_At",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("moment")(new Date(parseInt(item.updated_At)),"MMM DD YYYY"))+" ")]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-row',[_c('DeleteDeliverySchedule',{attrs:{"deliveryShift":item}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }